@if (loader()) {
	<div class="d-flex flex-column justify-content-center align-items-center h-400">
		@if (sendProgress() !== null) {
			<mat-progress-bar mode="determinate" [value]="sendProgress()"></mat-progress-bar>
			<span class="text-center mt-2 fw-bold">{{ sendProgress() }}%</span>
		} @else {
			<mat-spinner></mat-spinner>
		}
	</div>
} @else {
	<div class="overflow-auto" style="max-height: 80vh">
		<form>
			<div class="template-row">
				<mat-form-field class="template-select-field">
					<mat-label>Szablony</mat-label>
					<mat-select [(ngModel)]="selectedTemplate" name="templates">
						@for (template of templates(); track template.name) {
							<mat-option [value]="template">{{ template.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				@if (showInOneMailToggle()) {
					<div class="template-actions-slot">
						<span
							[matTooltip]="inOneMailDisabledTooltip()"
							[matTooltipDisabled]="inOneMailToggleEnabled() || !inOneMailDisabledTooltip()"
						>
							<mat-checkbox
								color="primary"
								[checked]="inOneMail()"
								[disabled]="!inOneMailToggleEnabled()"
								(change)="onInOneMailChange($event)"
							>
								Wyślij razem
							</mat-checkbox>
						</span>
					</div>
				}

				@if (isEmail() && showCcField()) {
					<mat-form-field class="template-cc-field">
						<mat-label>DW</mat-label>
						<input
							type="text"
							matInput
							[formControl]="ccControl"
							appMailList
							placeholder="example&#64;mail.com, example2&#64;mail.com"
						/>
						@if (ccControl.hasError('mailListSeparator')) {
							<mat-error
								>Adresy e-mail muszą być oddzielone przecinkiem i spacją (np. example&#64;gmail.com,
								example2&#64;gmail.com)</mat-error
							>
						} @else if (ccControl.hasError('mailListEmail')) {
							<mat-error>
								Nieprawidłowe adresy e-mail:
								{{ ccControl.getError('mailListEmail')?.invalid.join(', ') }}
							</mat-error>
						}
					</mat-form-field>
				}
			</div>

			<hr class="my-3" />

			@if (isCkEditorMode()) {
				<div class="message-generate-editor-field">
					<label class="message-generate-editor-label">
						Szablon {{ type() === MessageType.SMS ? 'SMS' : type() === MessageType.EMAIL ? 'mail' : '' }}
					</label>
					<ckeditor
						class="message-generate-editor"
						[editor]="editor"
						[config]="editorConfig"
						[formControl]="templateControl"
					></ckeditor>
				</div>
			} @else {
				<mat-form-field appearance="fill" class="w-100">
					<mat-label
						>Szablon {{ type() === MessageType.SMS ? 'SMS' : type() === MessageType.EMAIL ? 'mail' : '' }}
					</mat-label>
					<textarea
						matInput
						[formControl]="templateControl"
						rows="6"
						placeholder="Wpisz treść {{
							type() === MessageType.SMS ? 'sms' : type() === MessageType.EMAIL ? 'mail' : ''
						}}..."
					>
					</textarea>
				</mat-form-field>
			}

			<ng-container [ngTemplateOutlet]="templateErrorsTpl"></ng-container>

			<ng-template #templateErrorsTpl>
				@if (templateControl.hasError('required')) {
					<div class="message-generate-error">To pole jest wymagane</div>
				} @else if (templateControl.hasError('invalidTemplateVariables')) {
					<div class="message-generate-error">
						Znaleziono nieprawidłowe zmienne:
						{{ templateControl.getError('invalidTemplateVariables')?.invalid.join(', ') }}
					</div>
				} @else if (templateControl.hasError('invalidFormat')) {
					<div class="message-generate-error">
						Błędny format zmiennej:
						{{ templateControl.getError('invalidFormat')?.invalid.join(', ') }}
					</div>
				} @else if (templateControl.hasError('invalidHtmlTags')) {
					<div class="message-generate-error">
						Nieprawidłowe znaczniki HTML:
						{{ templateControl.getError('invalidHtmlTags')?.invalid.join('; ') }}
					</div>
				}
			</ng-template>
		</form>

		@if (!!propertiesKeys().length) {
			<hr class="my-3" />

			<div class="d-flex flex-wrap gap-3">
				@for (propertyValue of propertiesKeys(); track propertyValue) {
					<button
						[cdkCopyToClipboard]="propertyValue"
						(cdkCopyToClipboardCopied)="copied(propertyValue)"
						mat-stroked-button
					>
						{{ propertyValue }}
					</button>
				}
			</div>
		}

		@if (previewLoader() || previewList()?.length > 0 || previewErrorsList().length > 0) {
			<hr class="my-3" />

			<section [class]="isEmail() ? 'preview-list-container' : 'sms-list-container'">
				@if (previewLoader()) {
					<div class="my-5 d-flex justify-content-center">
						<div class="w-75">
							<mat-progress-bar mode="indeterminate"></mat-progress-bar>
						</div>
					</div>
				} @else {
					@if (previewTemplate(); as template) {
						<ng-container
							[ngTemplateOutlet]="template"
							[ngTemplateOutletContext]="{
								$implicit: previewList(),
								previewLoader: previewLoader(),
								attachmentsByItem: attachmentsByItem(),
								previewErrors: previewErrorsList(),
							}"
						></ng-container>
					}
				}
			</section>
		}

		<hr class="my-3" />
	</div>

	<div class="w-100 text-end">
		<button
			[disabled]="
				templateControl.invalid ||
				!previewList()?.length ||
				previewLoader() ||
				(isEmail() && showCcField() && ccControl.invalid)
			"
			mat-raised-button
			color="primary"
			(click)="send()"
		>
			Wyślij {{ type() === MessageType.SMS ? 'sms' : type() === MessageType.EMAIL ? 'mail' : '' }}
		</button>
	</div>
}
